export default function ChatDetailModal({ chatDetail, onClose }) {
  if (!chatDetail) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onClose}>
      <div className="bg-[hsl(var(--bg))] border border-[hsl(var(--line))] max-w-2xl w-full max-h-[85vh] overflow-y-auto p-8" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-6">
          <div className="kicker">Chat conversation</div>
          <button onClick={onClose} className="text-xs tracking-[0.3em] uppercase" data-testid="chat-modal-close">Close</button>
        </div>
        <div className="text-xs text-[hsl(var(--ink-soft))] mb-4">
          Started {new Date(chatDetail.created_at).toLocaleString()} · IP {chatDetail.ip || "?"}
        </div>
        {chatDetail.escalated && chatDetail.escalation && (
          <div className="border border-[hsl(var(--accent))] p-4 mb-6 text-sm">
            <div className="kicker text-[hsl(var(--accent))] mb-2">Escalated</div>
            <div><strong>{chatDetail.escalation.name}</strong> — <a className="text-[hsl(var(--accent))] underline" href={`mailto:${chatDetail.escalation.email}`}>{chatDetail.escalation.email}</a></div>
            {chatDetail.escalation.phone && <div>{chatDetail.escalation.phone}</div>}
            {chatDetail.escalation.note && <div className="mt-2 italic">{chatDetail.escalation.note}</div>}
          </div>
        )}
        <div className="space-y-3">
          {chatDetail.messages.map((m, i) => (
            <div key={`chat-msg-${i}-${m.role}`} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[85%] px-3 py-2 text-sm rounded ${m.role === "user" ? "bg-[hsl(var(--ink))] text-[hsl(var(--bg))]" : "bg-[hsl(var(--bg-alt))]"}`}>
                <div className="text-[10px] tracking-[0.25em] uppercase opacity-60 mb-1">{m.role}</div>
                <div className="whitespace-pre-wrap">{m.content}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
